import React from "react";
import { Button } from "@mui/material";
import { AtomicButtonProps } from "../../types/types";
import { useNavigate } from "react-router-dom";

const AtomicButton: React.FC<AtomicButtonProps> = ({
  variant = "contained",
  color = "primary",
  size = "medium",
  disabled = false,
  text,
  className,
  style,
  sxProps,
  to, 
  onClick, 
}) => {
  const navigate = useNavigate(); 
  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
   
    if (to) {
      //window.location.href = to; // Replace this with your preferred navigation method
      //to remove page reload use navigate from react-router-dom
      navigate(to)
    }
    if (onClick) {
      onClick(event); // Call the provided onClick function with the event
    }
  };
  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      disabled={disabled}
      className={className}
      style={style}
      sx={sxProps}
      disableRipple 
      onClick={handleClick} // Call handleClick function when the button is clicked
    >
      {text}
    </Button>
  );
};

export default AtomicButton;
